import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin_/login")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", replace: true });
  },
});
